import {
  Button,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

type DialogProps = {
  open: boolean;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void | Promise<void>;
  onCancel?: () => void;
  onClose: () => void;
  isShowCloseIcon?: boolean;
};

const Dialog = ({
  open,
  title,
  content,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  onClose,
  isShowCloseIcon = true,
}: DialogProps) => {
  const theme = useTheme();
  const showCancelButton = onCancel != null;

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          boxShadow: theme.customShadows.dialog,
          position: "relative",
          minWidth: "500px",
        },
      }}
    >
      {isShowCloseIcon && (
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1,
          }}
        >
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      )}
      {title && (
        <DialogTitle
          sx={{
            pr: isShowCloseIcon ? 6 : undefined, // 為關閉按鈕預留空間
          }}
        >
          {title}
        </DialogTitle>
      )}
      {content && (
        <DialogContent
          sx={{
            color: (theme) => theme.palette.text.secondary,
          }}
        >
          {content}
        </DialogContent>
      )}
      <DialogActions>
        {showCancelButton && (
          <Button
            color="inherit"
            variant="outlined"
            size="large"
            onClick={onCancel}
          >
            {cancelText}
          </Button>
        )}
        <Button variant="contained" size="large" onClick={onConfirm}>
          {confirmText}
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};

export default Dialog;
